/* ========================================
   HAFLA ABOUT PAGE - JAVASCRIPT
   ======================================== */

// Create sparkle/confetti particles in hero section
function createParticles() {
    const particlesContainer = document.getElementById('particles');
    if (!particlesContainer) return;

    const particleCount = 50;

    for (let i = 0; i < particleCount; i++) {
        const particle = document.createElement('div');
        particle.className = 'particle';

        // Random position
        particle.style.left = Math.random() * 100 + '%';
        particle.style.top = Math.random() * 100 + '%';

        // Random size
        const size = Math.random() * 3 + 2;
        particle.style.width = size + 'px';
        particle.style.height = size + 'px';

        // Random animation delay
        particle.style.animationDelay = Math.random() * 3 + 's';
        particle.style.animationDuration = (Math.random() * 2 + 2) + 's';

        particlesContainer.appendChild(particle);
    }
}

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', function () {
    createParticles();
    initKPICounters();
});

// ========================================
// KPI ANIMATED COUNTERS
// ========================================
function initKPICounters() {
    const kpiNumbers = document.querySelectorAll('.kpis__number');
    if (kpiNumbers.length === 0) return;

    // Check if Intersection Observer is supported
    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Start counting animation
                    animateCounters();
                    // Disconnect observer after animation starts (only run once)
                    observer.disconnect();
                }
            });
        }, {
            threshold: 0.3 // Trigger when 30% of section is visible
        });

        // Observe the KPIs section
        const kpisSection = document.getElementById('kpis');
        if (kpisSection) {
            observer.observe(kpisSection);
        }
    } else {
        // Fallback for browsers without Intersection Observer
        animateCounters();
    }
}

function animateCounters() {
    const kpiNumbers = document.querySelectorAll('.kpis__number');

    kpiNumbers.forEach(counter => {
        const target = parseInt(counter.getAttribute('data-target'));
        const suffix = counter.getAttribute('data-suffix') || '';
        const duration = 2000; // Animation duration in ms
        const startTime = performance.now();

        function updateCounter(currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);

            // Easing function for smooth animation (ease-out)
            const easeOutQuart = 1 - Math.pow(1 - progress, 4);
            const currentValue = Math.floor(target * easeOutQuart);

            // Format number with commas
            counter.textContent = formatNumber(currentValue) + suffix;

            if (progress < 1) {
                requestAnimationFrame(updateCounter);
            } else {
                // Ensure final value is exact
                counter.textContent = formatNumber(target) + suffix;
            }
        }

        requestAnimationFrame(updateCounter);
    });
}

function formatNumber(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
